import { render } from "./UploadDocumentZone.vue?vue&type=template&id=3f3428e8&scoped=true"
import script from "./UploadDocumentZone.vue?vue&type=script&lang=js"
export * from "./UploadDocumentZone.vue?vue&type=script&lang=js"

import "./UploadDocumentZone.vue?vue&type=style&index=0&id=3f3428e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3428e8"]])

export default __exports__